function Loading() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/90 print:hidden">
      <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}

export default Loading;
